import { CAPTURE_CAPABILITY } from 'ts-components/PiChat/protocol';
import type { PiChatStart } from 'ts-components/PiChat/usePiChat';

export type AiBlockPanelContext = {
  targetType: 'dashboard' | 'homepage' | 'chart_group';
  dashboardId: string;
  objectId?: string;
};

export interface ResolveConnectOptionsInput {
  url: string;
  context: AiBlockPanelContext;
  latest: { dashletId: string | null; conversationId: string | null };
  initial: { dashletId?: string; conversationId?: string };
}

export const resolveConnectOptions = ({
  url,
  context,
  latest,
  initial,
}: ResolveConnectOptionsInput): PiChatStart => {
  const start = {
    url,
    profile: 'block-builder',
    capabilities: [CAPTURE_CAPABILITY],
  } satisfies Partial<PiChatStart>;
  const baseContext = {
    targetType: context.targetType,
    dashboardId: context.dashboardId,
    ...(context.objectId ? { objectId: context.objectId } : {}),
  };
  const dashletId = latest.dashletId ?? initial.dashletId;
  if (!dashletId) {
    return {
      ...start,
      context: baseContext,
      ...(latest.conversationId
        ? { conversationId: latest.conversationId }
        : {}),
    };
  }
  const conversationId = latest.conversationId ?? initial.conversationId;
  return {
    ...start,
    context: { ...baseContext, dashletId },
    ...(conversationId ? { conversationId } : {}),
  };
};
